import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FamilySelection } from '@core/api/services/portal-member-import.service';
import { MemberAssociationSelectorComponent } from '@shared/components/member-association-selector/member-association-selector.component';

@Component({
  selector: 'app-family-import-comparison', standalone: true,
  imports: [CommonModule, FormsModule, MemberAssociationSelectorComponent],
  template: `<section class="family"><div class="head"><span>Vínculo</span><span>Portal</span><span>Comunidades</span></div>
    <div class="line" *ngFor="let row of rows; let index = index">
      <strong>{{ values(row)[0] }}</strong><span>{{ values(row).slice(1).join(' · ') }}</span>
      @if (excluded || !supported(row)) { <span>-</span> } @else {
        <div *ngIf="choice(index) as selected">
          <app-member-association-selector [associate]="selected.associate" (associateChange)="selected.associate = $event" [personId]="selected.personId" (personIdChange)="selected.personId = $event" [personName]="selected.personName" (personNameChange)="selected.personName = $event">
            @if (!selected.associate) { <span>{{ values(row)[1] || '-' }}</span> }
          </app-member-association-selector>
        </div>
      }
    </div></section>`,
  styles: [`.family{border:1px solid #d7e2ea;border-radius:.4rem;overflow:hidden}.head,.line{display:grid;gap:.75rem;grid-template-columns:.7fr 1fr 1.2fr;padding:.5rem .65rem}.head{background:#edf6fb;color:#174d78;font-size:.73rem;font-weight:700}.line{align-items:center;border-top:1px solid #e2edf4;color:#49616f;font-size:.76rem}.line>*{min-width:0;overflow-wrap:anywhere}.line strong{color:#174d78}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FamilyImportComparisonComponent {
  @Input() rows: string[] = [];
  @Input({ required: true }) selections: FamilySelection[] = [];
  @Input() excluded = false;
  values(row: string): string[] { return row.split(/\s*\u00b7\s*/).map(value => value.trim()); }
  supported(row: string): boolean { return ['padre', 'madre', 'father', 'mother', 'parent', 'hijo(a)', 'hijo', 'hija', 'child'].includes(this.values(row)[0].toLowerCase()); }
  choice(index: number): FamilySelection {
    let selected = this.selections.find(item => item.index === index);
    if (!selected) { selected = { index, associate: false }; this.selections.push(selected); }
    return selected;
  }
}
